import { useTranslation } from "react-i18next";
import {
  getPerformanceTask,
  useCreatePerformanceTask,
  useGetPerformanceTask,
} from "@packages/api/madlenAPI";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import { PerformanceTaskCard } from "../../../components/performance-task/PerformanceTaskCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";
import {
  PerformanceTaskCreateRequestDtoCourseName,
  PerformanceTaskResponseDto,
  PerformanceTaskResponseDtoAllOfCourseName,
} from "@packages/api/madlenAPI.schemas";
import i18n from "@packages/i18n/config";

const CreatePerformanceTaskView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("quickActions.performanceTasksCreate")}
      backPath="/content/performance-tasks"
      themeColor="ocean"
      loadingTitle={t("performanceTasks.submit.loading.title")}
      errorTitle={t("performanceTasks.submit.error.title")}
      errorDescription={t("performanceTasks.submit.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    isImageLoading,
    onCreateAgain,
  }: {
    toolData: PerformanceTaskResponseDto;
    isImageLoading: boolean;
    onCreateAgain: () => void;
  }) => (
    <PerformanceTaskCard
      id={toolData.id.toString()}
      createdAt={toolData.createdAt ?? ""}
      authorName={toolData.authorName ?? ""}
      performanceCriteria={toolData.performanceCriteria}
      imageUrl={toolData.imageUrl}
      videoUrl={toolData.videoUrl}
      prompt={toolData.title || toolData.prompt || ""}
      isImageLoading={isImageLoading}
      courseName={
        toolData.courseName || PerformanceTaskResponseDtoAllOfCourseName.ENGLISH
      }
      gradeLevel={toolData.gradeLevel ?? 0}
      description={toolData.description || ""}
      studentInstructions={toolData.studentInstructions || ""}
      materialsNeeded={toolData.materialsNeeded}
      onCreateAgain={onCreateAgain}
      contentLanguage={toolData.contentLanguage || i18n.language}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="performance-task"
      useCreateTool={useCreatePerformanceTask}
      useGetTool={useGetPerformanceTask}
      getTool={getPerformanceTask}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: PerformanceTaskResponseDto) =>
        data?.performanceCriteria && data?.performanceCriteria?.length > 0
      }
    />
  );
};

export default CreatePerformanceTaskView;
